import { render, staticRenderFns } from "./CourseCategoryCreate.vue?vue&type=template&id=05fb96bc&"
import script from "./CourseCategoryCreate.vue?vue&type=script&lang=js&"
export * from "./CourseCategoryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports